import { render } from "./LeftBar.vue?vue&type=template&id=15b55fb2"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/vshemyatin/phonebook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__